import { render, staticRenderFns } from "./TagServiceType.vue?vue&type=template&id=5d486c34&scoped=true"
import script from "./TagServiceType.vue?vue&type=script&lang=js"
export * from "./TagServiceType.vue?vue&type=script&lang=js"
import style0 from "./TagServiceType.vue?vue&type=style&index=0&id=5d486c34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d486c34",
  null
  
)

export default component.exports